export default __webpack_public_path__ + "static/47469-8eac925eec39d4419cac27aeb9fb7e83.jpg";